import { getApi } from '../../../api';
import { travel_type } from '../../../utils/constants';

export async function getUsers() {
  try {
    //* *Make get users */
    const response = await getApi().get('/users', { data: {} });

    return response;
  } catch (e) {
    // console.log("e:");
    // console.log(e.status);
  }
}

export async function getVehicles() {
  try {
    //* *Make get users */
    const response = await getApi().get('/vehicles', { data: {} });

    return response;
  } catch (e) {
    // console.log("e:");
    // console.log(e.status);
  }
}

export async function getVehicle(id) {
  try {
    //* *Make get users */
    const response = await getApi().get(`/vehicles/${id}`, { data: {} });

    return response;
  } catch (e) {
    // console.log("e:");
    // console.log(e.status);
  }
}
export async function getBookings(options = {}) {
  try {
    const params = new URLSearchParams();
    const { status, page, rowsPerPage, dateRange } = options;
    if (status) params.append("by_status", status);
    if (page) params.append("page", page);
    if (rowsPerPage) params.append("per_page", rowsPerPage);
    if (dateRange) {
      params.append("by_date_range[start_date]", [dateRange.start_date]);
      params.append("by_date_range[end_date]", [dateRange.end_date])
    };

    const response = await getApi().get(`/bookings${params.toString() ? `?${params.toString()}` : ''}`, {
      data: {},
    });
    return response;
  } catch (e) {}
}

export async function postBooking(bookingValues) {
  try {
    //* *Make post booking */
    let formData = new FormData();

    formData.append('travel_type', bookingValues.travel_type);
    formData.append('status', 'requested');
    formData.append('origin', bookingValues.origin);
    formData.append('destination', bookingValues.destination);
    formData.append('second_origin', bookingValues.second_origin);
    formData.append('second_destination', bookingValues.second_destination);
    formData.append('departure_datetime', bookingValues.departure_datetime);
    formData.append('return_datetime', bookingValues.return_datetime);
    formData.append('passengers_number', bookingValues.passengers_number);
    formData.append('observations', bookingValues.observations);

    if (!!bookingValues.documents) {
      bookingValues.documents.forEach(file => formData.append('documents[]', file));
    }

    const response = await getApi().post(
      `/users/${bookingValues.user_id}/bookings`,
      formData,
      {
        headers: { 'content-type': 'multipart/form-data' }
      },
    );

    return response;
  } catch (e) {}
}

export async function updateBooking(bookingValues) {
  try {
    //* * Make a update booking */
    const booking = {
      origin: bookingValues.origin,
      destination: bookingValues.destination,
      second_origin: bookingValues.travel_type !== 'multi_places' ? '' : bookingValues.second_origin,
      second_destination: bookingValues.travel_type !== 'multi_places' ? '' : bookingValues.second_destination,
      departure_datetime: bookingValues.departure_datetime,
      return_datetime: bookingValues.travel_type === 'one_way' ? '' : bookingValues.return_datetime,
      passengers_number: bookingValues.passengers_number,
      observations: bookingValues.observations,
      travel_type: bookingValues.travel_type
    };

    const response = await getApi().put(
      `/users/${bookingValues.user_id}/bookings/${bookingValues.id}`,
      booking,
      '',
    );

    return response;
  } catch (e) {}
}

export async function updateBookingFiles(bookingValues) {
  try {
    //* *Make post booking */
    let formData = new FormData();

    if (!!bookingValues.documents) {
      bookingValues.documents.forEach(file => formData.append('documents[]', file));
    }
    

    const response = await getApi().put(
      `/users/${bookingValues.user_id}/bookings/${bookingValues.id}`,
      formData,
      {
        headers: { 'Access-Control-Expose-Headers': 'Content-Disposition', 'Content-Type': 'multipart/form-data' }
      },
    );

    return response;
  } catch (e) {}
}

export async function deleteBookingFile(bookingValues) {
  try {
    const response = await getApi().delete(
      `/bookings/${bookingValues.id}/documents/${bookingValues.documentId}`,
      { data: {} },
      '',
    );

    return response;
  } catch (e) {}
}

export async function downloadBookingFile(bookingValues) {
  const { document, id } = bookingValues;
  try {
    const response = await getApi().get(
      `/bookings/${id}/documents/${document.id}`,
      { data: {} },
      {
        headers: { 'Content-Type': 'application/json' }
      },
    );
    
    if (response.status === 200) {
      const win = window.open(response.request.responseURL, '_blank');
      win.focus();
    }

    return null;
  } catch (e) {}
}

export async function downloadExcel(options = {}) {
  try {
    const params = new URLSearchParams();
    const { status, dateRange } = options;
    if (status) params.append("by_status", status);
    if (dateRange) {
      params.append("by_date_range[start_date]", [dateRange.start_date]);
      params.append("by_date_range[end_date]", [dateRange.end_date])
    };
    const response = await getApi().get(`/bookings/export_excel${params.toString() ?
      `?${params.toString()}` : ''}`,
      { responseType: 'blob' }
    );
    return response;
  } catch (e) {
    return e.response;
  }
};
